export default __webpack_public_path__ + "media/src/assets/images/load_green-9b171e55a9df93e214fb1a139c669ca5.png";